/** @format */

import { useEffect } from "react";
import { useNavigate } from "fusion-plugin-react-router";
import {
  UBER_AUTH_CLIENT_ID,
  UBER_AUTH_RESPONSE_TYPE,
  UBER_AUTH_REDIRECT_PORTAL_LOGIN_PATH,
} from "../config/config";
import Navbar from "../shared/components/navbar";
import Footer from "../shared/components/footer";
import PageContent from "../shared/components/PageContent";
import QuoteStepLoader from "../shared/components/QuoteStepLoader";
import { captureReferralTracking } from "../shared/utils/referralTracking";

const UberAuthRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    captureReferralTracking();

    // Now redirect to Uber OAuth
    window.location.href = `https://login.uber.com/oauth/v2/authorize?client_id=${UBER_AUTH_CLIENT_ID}&response_type=${UBER_AUTH_RESPONSE_TYPE}&redirect_uri=${window
      .location.origin + UBER_AUTH_REDIRECT_PORTAL_LOGIN_PATH}`;
  }, [navigate]);

  return (
    <>
      <Navbar />
      <PageContent>
        <QuoteStepLoader
          title="Taking you to Uber"
          description="Log in on Uber's page and you will come back here automatically. Check the address shows uber.com."
          message="Connecting securely to Uber..."
        />
      </PageContent>
      <Footer />
    </>
  );
};

export default UberAuthRedirect;
